export default {
  title: 'Configuration spécifique aux programmes à puzzle'
}
